/* Merchant delivery calendar only: no destination, inventory or checkout verification. */
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.SaberLocalDeliveryCalendar = factory();
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";
  const timezone = "America/Denver";
  let formatter;
  const key = (date) => date.toISOString().slice(0, 10);
  function parseDay(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value))
      return null;
    const date = new Date(value + "T00:00:00Z");
    return Number.isFinite(date.valueOf()) && key(date) === value ? date : null;
  }
  const result = (status) => ({
    status,
    date: null,
    dateEnd: null,
    mode: null,
  });
  function openDay(date, additionalClosures) {
    if ([0, 6].includes(date.getUTCDay())) return false;
    const day = key(date);
    if (additionalClosures.has(day)) return false;
    if (["01-01", "07-04", "12-24", "12-25"].includes(day.slice(5)))
      return false;
    // Thanksgiving: the fourth Thursday of November, with no invented observed days.
    return !(
      date.getUTCMonth() === 10 &&
      date.getUTCDay() === 4 &&
      date.getUTCDate() >= 22 &&
      date.getUTCDate() <= 28
    );
  }
  function estimate({ now, postalCode, countryCode, policy } = {}) {
    const country =
      typeof countryCode === "string" ? countryCode.trim().toUpperCase() : "";
    if (!country) return result("confirm");
    if (country !== "US") return result("outside_area");
    const postal =
      typeof postalCode === "string"
        ? postalCode.trim().match(/^(\d{5})(?:-?\d{4})?$/)
        : null;
    if (
      !postal ||
      !policy ||
      !Array.isArray(policy.sameDayPostalCodes) ||
      !policy.sameDayPostalCodes.length
    )
      return result("confirm");
    if (
      policy.sameDayPostalCodes.some(
        (value) => typeof value !== "string" || !/^\d{5}$/.test(value),
      )
    )
      return result("confirm");
    if (!policy.sameDayPostalCodes.includes(postal[1]))
      return result("outside_area");
    const closures =
      policy.additionalClosures === undefined ? [] : policy.additionalClosures;
    if (!Array.isArray(closures) || closures.some((value) => !parseDay(value)))
      return result("confirm");
    const additionalClosures = new Set(closures);
    const timestamp =
      now === undefined
        ? Date.now()
        : now instanceof Date
          ? now.valueOf()
          : typeof now === "number"
            ? now
            : NaN;
    if (!Number.isFinite(timestamp)) return result("confirm");
    try {
      formatter ||= new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
      const clock = Object.fromEntries(
        formatter
          .formatToParts(new Date(timestamp))
          .map((part) => [part.type, part.value]),
      );
      const date = parseDay(`${clock.year}-${clock.month}-${clock.day}`);
      if (!date) return result("confirm");
      const sameDay =
        Number(clock.hour) * 60 + Number(clock.minute) < 11 * 60 + 59 &&
        openDay(date, additionalClosures);
      if (!sameDay) {
        let found = false;
        for (let count = 0; count < 800; count++) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (openDay(date, additionalClosures)) {
            found = true;
            break;
          }
        }
        if (!found) return result("confirm");
      }
      const day = key(date);
      if (!parseDay(day)) return result("confirm");
      return {
        status: "estimated",
        date: day,
        dateEnd: day,
        mode: sameDay ? "same-day" : "next-business-day",
      };
    } catch {
      return result("confirm");
    }
  }
  return Object.freeze({ estimate });
});
